import Icon from '@/componentsDS/Icon/Icon';
import PropTypes from 'prop-types';

// Error / info / caption line shown under DS inputs (Input, InputDropdownSelect)
const InputCaption = ({ id, errorMessage, infoText, captionText }) => (
	<div className="DS__input-caption">
		{errorMessage && (
			<>
				<Icon name="exclamation-circle" style="solid" size="small" color="#b4371b" />
				<div id={`${id}-error`} className="DS__input-error-message">
					{errorMessage}
				</div>
			</>
		)}
		{infoText && (
			<>
				<Icon name="information-circle" style="solid" size="small" color="#0061c1" />
				<div id={`${id}-help`} className="DS__input-info-text">
					{infoText}
				</div>
			</>
		)}
		{captionText}
	</div>
);

export default InputCaption;

InputCaption.propTypes = {
	id: PropTypes.string,
	errorMessage: PropTypes.string,
	infoText: PropTypes.string,
	captionText: PropTypes.string,
};
